import { initConsent } from './consent';

// Initialisiert das self-hosted Consent-Management (vanilla-cookieconsent) vor
// dem React-Render. Google Analytics / YouTube / Deezer werden ausschließlich
// nach Einwilligung geladen (consent.js bzw. Library.jsx) — kein Vorab-Laden,
// kein Kontakt zu Dritt-CDNs vor Consent.
document.addEventListener('DOMContentLoaded', () => {
  initConsent();
});
